import Vue from "vue";
import App from "@/App.vue";
import vuetify from "@/plugins/vuetify";

import router from "@/plugins/router";
import store from "@/plugins/store";
import { pushInterceptor } from "@/plugins/axios";
import { initAuth } from "@/plugins/auth";

import "@/plugins/moment";
import "@/plugins/swal";
import "@/plugins/sentry";

Vue.config.productionTip = false;

pushInterceptor(Vue.axios, store);

initAuth(store).finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
